import type { Messages } from './en';

export const es: Messages = {
  "language.label": "Idioma",
  "auth.login": "Iniciar sesión",
  "auth.signup": "Crear cuenta",
  "auth.signupTitle": "Crea tu cuenta",
  "auth.signupLead": "Crea tu cuenta, confirma tu email y tu prueba gratuita puede empezar al momento.",
  "auth.loginLead": "Inicia sesión con tu email o con el nombre de usuario que te enviamos.",
  "auth.passwordChanged": "Contraseña cambiada. Inicia sesión con tu nueva contraseña.",
  "auth.name": "Tu nombre",
  "auth.email": "Email",
  "auth.emailOrUsername": "Email o nombre de usuario",
  "auth.whatsapp": "Número de WhatsApp",
  "auth.whatsappHint": "Para poder contactarte por WhatsApp.",
  "auth.password": "Contraseña",
  "auth.keepLoggedIn": "Mantener la sesión iniciada en este dispositivo",
  "auth.wait": "Espera…",
  "auth.forgot": "¿Olvidaste tu contraseña?",
  "auth.enterName": "Escribe tu nombre.",
  "auth.weakPassword": "Elige una contraseña más segura: debe cumplir todos los puntos de la lista bajo la contraseña.",
  "auth.deviceUnsupported": "Este dispositivo no es compatible.",
  "auth.loginAgain": "Vuelve a iniciar sesión.",
  "auth.accountDeleted": "Tu cuenta se ha eliminado.",
  "password.rules": "Requisitos de la contraseña",
  "password.length": "Al menos 8 caracteres",
  "password.upper": "Una letra mayúscula",
  "password.lower": "Una letra minúscula",
  "password.number": "Un número",
  "password.done": "(hecho)",
  "password.missing": "(falta)",
  "phone.country": "País: {name}, +{dial}",
  "phone.placeholder": "612 34 56 78",
  "phone.search": "Busca tu país",
  "phone.countries": "Países",
  "phone.noCountry": "No se encontró ningún país",
  "reset.title": "Restablece tu contraseña",
  "reset.sent": "Si {email} tiene una cuenta, le hemos enviado un código de 6 cifras. Escríbelo con tu nueva contraseña.",
  "reset.lead": "Escribe tu email y te enviaremos un código.",
  "reset.code": "Código",
  "reset.newPassword": "Nueva contraseña",
  "reset.save": "Guardar la nueva contraseña",
  "reset.send": "Enviar código",
  "reset.back": "Volver a iniciar sesión",
  "catalog.title": "¿En qué idiomas ves la tele?",
  "catalog.lead": "Tus canales, películas y series estarán en estos idiomas, para que la app cargue rápido en tu móvil y tu TV.",
  "catalog.continue": "Continuar",
  "catalog.languages": "Idiomas",
  "catalog.more": "Más idiomas…",
  "catalog.international": "También películas y series internacionales",
  "catalog.internationalHint": "(sin idioma concreto, p. ej. «Películas Netflix»: la lista crece)",
  "catalog.note": "Los partidos de hoy en Inicio siguen disponibles en todos los idiomas. Puedes cambiarlo cuando quieras en Cuenta.",
  "catalog.saving": "Guardando…",
  "catalog.chooseOne": "Elige al menos un idioma",
  "verify.title": "Confirma tu email",
  "verify.lead": "Hemos enviado un código de 6 cifras a {email}. Escríbelo abajo. Mira en spam si no lo ves.",
  "verify.code": "Código",
  "verify.newCodeSent": "Un código nuevo está en camino.",
  "verify.checking": "Comprobando…",
  "verify.confirm": "Confirmar",
  "verify.resend": "Enviar un código nuevo",
  "noAccess.noPlan.title": "Empieza tu prueba gratuita",
  "noAccess.noPlan.body": "Pide tu prueba gratuita y míralo todo en este dispositivo. La mayoría de las pruebas empiezan al momento; tu tiempo empieza cuando pones algo por primera vez.",
  "noAccess.noPlan.contact": "Hola, me gustaría suscribirme a IPTViva.",
  "noAccess.pending.title": "Prueba solicitada",
  "noAccess.pending.body": "Hemos recibido tu solicitud y activaremos tu prueba gratuita en breve. Esta pantalla abre los canales en cuanto esté activa.",
  "noAccess.pending.contact": "Hola, he pedido una prueba gratuita en IPTViva.",
  "noAccess.used.title": "Prueba gratuita ya usada",
  "noAccess.used.body": "Este dispositivo, número o email ya tuvo una prueba gratuita. Suscríbete para seguir viendo.",
  "noAccess.used.contact": "Hola, ya usé mi prueba gratuita y me gustaría suscribirme a IPTViva.",
  "noAccess.trialEnded.title": "Tu prueba gratuita ha terminado",
  "noAccess.trialEnded.body": "Esperamos que te haya gustado. Suscríbete para seguir viendo: Standard para una pantalla, Premium para dos a la vez.",
  "noAccess.trialEnded.contact": "Hola, mi prueba gratuita ha terminado y me gustaría suscribirme a IPTViva.",
  "noAccess.expired.title": "Tu suscripción ha terminado",
  "noAccess.expired.body": "Renueva tu suscripción para seguir viendo.",
  "noAccess.expired.contact": "Hola, me gustaría renovar mi suscripción a IPTViva.",
  "noAccess.sending": "Enviando…",
  "noAccess.request": "Pedir la prueba gratuita",
  "noAccess.waiting": "Esperando la activación…",
  "noAccess.contactWhatsapp": "Contactar por WhatsApp",
  "noAccess.subscribeWhatsapp": "Suscribirse por WhatsApp",
  "noAccess.loggedInAs": "Sesión iniciada como {name}",
  "common.logOut": "Cerrar sesión",
  "common.cancel": "Cancelar",
  "common.back": "Atrás",
  "common.tryAgain": "Reintentar",
  "delete.link": "Eliminar mi cuenta",
  "delete.title": "¿Eliminar tu cuenta?",
  "delete.body": "Tu cuenta y sus datos se eliminan para siempre. Escribe tu contraseña para confirmar.",
  "delete.deleting": "Eliminando…",
  "delete.confirm": "Eliminar la cuenta",
  "unverified.title": "No se puede comprobar tu acceso",
  "unavailable.title": "IPTViva no está disponible",
  "unavailable.device": "No se pudo identificar este dispositivo. Reinicia la app e inténtalo de nuevo.",
  "unavailable.build": "Esta versión no tiene servidor de cuentas configurado (VITE_ACCOUNT_API).",
  "error.invalid-credentials": "Email, nombre de usuario o contraseña incorrectos.",
  "error.account-disabled": "Esta cuenta está desactivada. Contáctanos.",
  "error.trial-used-on-device": "Este dispositivo ya tuvo una prueba gratuita. Inicia sesión con una cuenta suscrita o contáctanos para suscribirte.",
  "error.trial-bound-to-other-device": "Tu prueba gratuita ya se usa en tu otro dispositivo. Suscríbete para ver en más dispositivos.",
  "error.device-limit": "Esta cuenta ya se usa en todos los dispositivos que permite su plan. Para usarla en uno nuevo, contacta con soporte.",
  "error.unsupported-device": "Este dispositivo no es compatible.",
  "error.rate-limited": "Demasiados intentos. Espera un poco e inténtalo de nuevo.",
  "error.session-ended": "Se ha cerrado tu sesión. Vuelve a iniciarla.",
  "error.invalid-email": "Escribe un email válido.",
  "error.disposable-email": "No se aceptan emails temporales. Usa tu email habitual.",
  "error.invalid-phone": "Escribe tu número de WhatsApp con el prefijo del país.",
  "error.weak-password": "Elige una contraseña más segura: al menos 8 caracteres, con una mayúscula, una minúscula y un número.",
  "error.missing-name": "Escribe tu nombre.",
  "error.email-taken": "Ya existe una cuenta con este email. Inicia sesión.",
  "error.wrong-password": "Contraseña incorrecta.",
  "error.invalid-code": "Código incorrecto o caducado. Revisa el email o pide uno nuevo.",
  "error.code-too-soon": "Acabamos de enviar un código. Espera un minuto antes de pedir otro.",
  "error.not-active": "Tu cuenta no tiene un plan activo.",
  "error.email-unavailable": "Restablecer la contraseña por email aún no está disponible. Escríbenos por WhatsApp y te enviaremos una nueva.",
  "error.invalid-input": "Elige al menos un idioma.",
  "error.server-error": "Algo ha fallado. Inténtalo de nuevo.",
  "error.offline": "No se puede conectar con el servidor. Revisa tu conexión a internet.",
  "error.not-configured": "El servidor de cuentas no está configurado en esta versión.",
  "common.close": "Cerrar",
  "common.dismiss": "Cerrar",
  "common.loading": "Cargando…",
  "nav.main": "Principal",
  "nav.home": "Inicio",
  "nav.live": "TV en directo",
  "nav.movies": "Películas",
  "nav.series": "Series",
  "nav.search": "Buscar",
  "nav.account": "Cuenta",
  "kind.live": "Directo",
  "kind.movie": "Película",
  "kind.series": "Serie",
  "tile.sports": "Deporte en directo",
  "tile.movies": "Películas",
  "tile.series": "Series",
  "tile.kids": "Infantil",
  "tile.music": "Música",
  "tile.news": "Noticias",
  "tile.uhd": "4K UHD",
  "tile.docs": "Documentales",
  "tile.football": "Fútbol",
  "tile.cinema": "Cine",
  "tile.cartoons": "Dibujos animados",
  "tile.concerts": "Conciertos",
  "sync.connecting": "Conectando",
  "sync.downloading": "Descargando la lista",
  "sync.live": "Cargando canales en directo",
  "sync.movie": "Cargando películas",
  "sync.series": "Cargando series",
  "sync.saving": "Guardando",
  "sync.starting": "Empezando",
  "sync.items": "{count} elementos",
  "sync.of": "{done} de {total}",
  "sync.adding": "Cargando {name}",
  "sync.updating": "Actualizando {name}",
  "sync.importing": "Importando {name}",
  "sync.busy": "La lista de canales aún se está actualizando. Espera a que termine.",
  "errors.refused": "El proveedor rechazó la solicitud. Comprueba que la cuenta está activa y no supera su límite de conexiones.",
  "errors.notFound": "La dirección no existe en el servidor.",
  "errors.serverProblem": "El servidor del proveedor informó de un problema. Asegúrate de que ningún otro dispositivo usa esta cuenta, espera un minuto e inténtalo de nuevo.",
  "errors.network": "No se puede conectar con el servidor. Revisa tu conexión a internet.",
  "errors.timeout": "El servidor tardó demasiado en responder. Inténtalo más tarde.",
  "errors.http": "El servidor devolvió un error.",
  "errors.bad-credentials": "Usuario o contraseña incorrectos.",
  "errors.account-expired": "Esta cuenta ha caducado. Contáctanos.",
  "errors.account-disabled": "Esta cuenta está desactivada. Contáctanos.",
  "errors.empty-playlist": "La lista no contiene canales ni vídeos.",
  "errors.parse": "No se pudo leer la lista.",
  "errors.invalid-input": "Faltan datos o no son válidos.",
  "errors.storage": "No se pudieron guardar los datos en este dispositivo. Libera espacio e inténtalo de nuevo.",
  "errors.cancelled": "Cancelado.",
  "search.all": "Todo",
  "search.placeholder": "Canales, películas, series",
  "search.tooShort": "Escribe al menos {count} caracteres.",
  "search.none": "Sin resultados",
  "search.results": "{count} resultados",
  "filter.language": "Idioma",
  "filter.allLanguages": "Todos los idiomas",
  "filter.country": "País",
  "filter.allCountries": "Todos los países",
  "browse.loadingChannels": "Cargando tus canales… Si no aparece nada, abre Cuenta y toca Cargar canales.",
  "browse.source": "Origen",
  "browse.categories": "Categorías",
  "browse.other": "Otros",
  "browse.recent": "Añadidos recientemente",
  "browse.front": "Destacados",
  "browse.continue": "Seguir viendo",
  "browse.seeAll": "Ver todo",
  "browse.previous": "Anterior",
  "browse.next": "Siguiente",
  "browse.episodes": "Episodios",
  "browse.watched": "Vistos recientemente",
  "favorites.title": "Favoritos",
  "favorites.add": "Añadir {name} a favoritos",
  "favorites.remove": "Quitar {name} de favoritos",
  "series.continue": "Continuar {episode} desde {time}",
  "browse.allFiltered": "Todo {filter}",
  "browse.empty.live": "Aquí no hay canales en directo.",
  "browse.empty.movie": "Aquí no hay películas.",
  "browse.empty.series": "Aquí no hay series.",
  "browse.unfinished": "{kind} no terminó de cargarse.",
  "browse.load.live": "Cargar canales en directo",
  "browse.load.movie": "Cargar películas",
  "browse.load.series": "Cargar series",
  "browse.loading.live": "Cargando canales en directo…",
  "browse.loading.movie": "Cargando películas…",
  "browse.loading.series": "Cargando series…",
  "browse.meanwhile": "Mientras tanto, {count} canales en directo están listos en TV en directo.",
  "series.loading": "Cargando episodios…",
  "series.seasons": "Temporadas",
  "account.username": "Nombre de usuario",
  "account.name": "Nombre",
  "account.plan": "Plan",
  "account.freeTrial": "Prueba gratuita",
  "account.screens": "Pantallas a la vez",
  "account.unlimited": "Ilimitadas",
  "account.trialEndsIn": "La prueba termina en",
  "account.validUntil": "Válido hasta",
  "account.trialNotStarted": "{length} · empieza cuando pones algo",
  "account.noEnd": "Sin fecha de fin",
  "account.content": "Contenido",
  "account.lastLoad": "Última carga",
  "account.lastLoadDetail": "{total} ({waiting} esperando al servidor, {download} descargando, {storing} guardando en este dispositivo)",
  "account.loading.live": "canales cargando…",
  "account.loading.movie": "películas cargando…",
  "account.loading.series": "series cargando…",
  "account.count.live": "{count} canales",
  "account.count.movie": "{count} películas",
  "account.count.series": "{count} series",
  "account.updateChannels": "Actualizar canales",
  "account.loadChannels": "Cargar canales",
  "account.subscribe": "Suscribirse",
  "account.renew": "Renovar",
  "account.subscribeMessage": "Hola, me gustaría suscribirme a IPTViva.",
  "account.renewMessage": "Hola, me gustaría renovar mi suscripción a IPTViva.",
  "account.helpMessage": "Hola, necesito ayuda con IPTViva.",
  "account.help": "Ayuda",
  "account.helpText": "¿Una pregunta, un dispositivo nuevo o un canal que no funciona? Contáctanos, respondemos todos los días.",
  "account.appLanguage": "Idioma de la app",
  "account.channelLanguages": "Idiomas de los canales",
  "account.international": "internacional",
  "account.saveLanguages": "Guardar y recargar mi lista",
  "account.languagesSaved": "Guardado. Tu lista de canales se está recargando con estos idiomas.",
  "account.changeLanguages": "Cambiar idiomas",
  "time.minutes": "{count} min",
  "time.hoursMinutes": "{hours} h {minutes} min",
  "time.days": "{count} días",
  "time.hour": "{count} hora",
  "time.hours": "{count} horas",
  "home.loading": "Cargando los partidos de hoy…",
  "home.failed": "No se pudieron cargar los partidos de hoy. Esta página lo vuelve a intentar cada minuto.",
  "home.welcome": "Bienvenido",
  "home.noMatches": "Ahora no hay grandes partidos de fútbol. Aparecen aquí en cuanto encontramos canales que los emiten y funcionan bien.",
  "home.liveNow": "En directo",
  "home.laterToday": "Más tarde hoy",
  "home.otherLeagues": "Otras",
  "home.favouriteLeague": "Marcar {league}: mostrar primero",
  "home.unfavouriteLeague": "Quitar {league} de favoritos",
  "home.browse": "Explorar",
  "home.allChannels": "Todos los canales",
  "home.anyTime": "Cuando quieras",
  "home.everyEpisode": "Todos los episodios",
  "home.todaysMatches": "Partidos de hoy",
  "home.slideOf": "{position} de {count}",
  "home.previousMatch": "Partido anterior",
  "home.nextMatch": "Partido siguiente",
  "home.football": "Fútbol",
  "home.checking": "Comprobando canales…",
  "home.channelIn": "{count} canal en {language}",
  "home.channelsIn": "{count} canales en {language}",
  "home.moreOther": "{count} más en otros idiomas",
  "home.noChannel": "Aún no hay canal",
  "home.atKickoff": "Los canales aparecen al empezar el partido, una vez comprobados",
  "home.channelsAtKickoff": "Canales al empezar",
  "home.tomorrow": "Mañana",
  "home.days": "Días",
  "home.comingUp": "Próximamente",
  "home.seeDay": "Ver {day}",
  "home.channelsOnMatchDay": "Canales el día del partido",
  "home.noMatchToday": "Sin partido hoy, próximo {date}",
  "home.noMatchDay": "Sin partido este día, próximo {date}",
  "home.noMatchesDay": "No hay partidos de las grandes ligas este día.",
  "home.noSchedule": "La programación de los próximos días aún no está disponible.",
  "home.watchNow": "Ver ahora",
  "home.details": "Detalles",
  "home.today": "Hoy",
  "home.inMinutes": "en {count} min",
  "home.inHours": "en {count} h",
  "home.oneChannel": "{count} canal",
  "home.channels": "{count} canales",
  "home.oneLanguage": "{count} idioma",
  "home.languages": "{count} idiomas",
  "home.checkingLong": "Estamos comprobando los canales que emiten este partido. Los que funcionan aparecen aquí en un minuto o dos.",
  "home.atKickoffLong": "Los canales aparecen aquí al empezar el partido, una vez comprobado que funcionan bien.",
  "home.expectedOn": "Previsto en {name} · aún sin comprobar",
  "home.expectedOnMore": "Previsto en {name} +{count} · aún sin comprobar",
  "home.willBeOn": "Aún sin comprobar: estos canales se podrán ver cuando hayamos comprobado que funcionan bien.",
  "home.mightBeOn": "Quizás en {name}",
  "home.mightBeOnMore": "Quizás en {name} +{count}",
  "home.mightHave": "Podrían tener el partido: toca uno para probarlo.",
  "home.mightHaveShort": "Quizás tenga el partido",
  "home.moreToTry": "Más canales para probar",
  "home.notChecked": "Sin comprobar",
  "home.searchMore": "Buscar más",
  "home.searchHint": "¿No está en la lista? Busca los canales {channels}.",
  "home.searchHintClubs": "¿No está en la lista? Busca los canales de los clubes o la cadena que lo emite.",
  "home.commentary": "Idioma de los comentarios",
  "home.playsSmoothly": "Funciona bien",
  "home.mayShowOther": "Puede mostrar otro partido",
  "home.guessesBefore": "El partido está en uno de los canales numerados, pero aún no sabemos en cuál. Durante el partido, los espectadores nos ayudan a encontrarlo.",
  "home.guessesLive": "El partido está en uno de los canales numerados, pero aún no sabemos en cuál. Prueba uno: te preguntaremos si el partido está ahí.",
  "home.confirmedByViewers": "Confirmado por espectadores",
  "player.matchQuestion": "¿Está {match} en este canal?",
  "player.matchYes": "Sí",
  "player.matchNo": "No",
  "player.matchThanks": "¡Gracias! Cuando suficientes espectadores coincidan, todos verán la respuesta.",
  "home.notConfirmed": "Sin confirmar: puede ser un partido juvenil",
  "home.watchedNow": "Viéndose ahora · empieza al instante",
  "clock.live": "DIRECTO",
  "clock.ht": "DESC",
  "clock.break": "Pausa",
  "clock.penalties": "Penaltis",
  "clock.ft": "FIN",
  "clock.paused": "Suspendido",
  "player.buffering": "Cargando…",
  "player.reconnecting": "Reconectando…",
  "player.paused": "En pausa",
  "player.pausedByOtherApp": "En pausa por otra aplicación (¿una llamada?). Toca Reproducir para ver en directo.",
  "player.soundOffByOtherApp": "El sonido está apagado mientras otra aplicación (¿una llamada?) lo usa. Toca para activarlo.",
  "player.soundOffShort": "Sin sonido (¿una llamada?) · toca para activarlo",
  "player.finished": "Terminado",
  "player.connecting": "Conectando…",
  "player.queueTitle": "Tu prueba gratuita empieza en",
  "player.queueNext": "Eres el siguiente.",
  "player.queuePosition": "Eres el número {position} en la cola.",
  "player.queueBody": "Ahora todas las plazas de prueba están ocupadas. La reproducción empieza sola, así que deja esta pantalla abierta. Tu tiempo de prueba empieza cuando consigas plaza.",
  "player.anyMoment": "En cualquier momento…",
  "player.uhdTitle": "El 4K y el 8K no son compatibles con este dispositivo",
  "player.uhdBody": "Este dispositivo no puede reproducir 4K ni 8K, así que este título no está disponible aquí y el catálogo no tiene una versión HD. Cambia a otro dispositivo, como un televisor, ordenador o teléfono más reciente, para tener el catálogo completo.",
  "browse.uhdHidden": "Los títulos en 4K y 8K están ocultos: este dispositivo no puede reproducirlos. Cambia a otro dispositivo para tener el catálogo completo.",
  "browse.uhdPaused": "Los títulos en 4K y 8K están en pausa por ahora: ves las versiones HD. Las apps de TV para LG y Samsung siguen teniendo el catálogo completo.",
  "player.uhdPausedTitle": "El 4K y el 8K están en pausa por ahora",
  "player.uhdPausedBody": "Los títulos en 4K y 8K no están disponibles aquí por ahora, y este no tiene versión HD. Vuelve a intentarlo más tarde o usa nuestra app de TV para LG o Samsung para tener el catálogo completo.",
  "player.uhdPausedSwitched": "El 4K está en pausa por ahora: se reproduce la versión HD.",
  "player.uhdSwitched": "Este dispositivo no reproduce 4K: se reproduce la versión HD.",
  "player.renewBody": "Renuévala para seguir viendo.",
  "player.trialEndedBody": "Esperamos que te haya gustado. Suscríbete para seguir viendo.",
  "player.fullOne": "Ya se está viendo en {count} pantalla",
  "player.full": "Ya se está viendo en {count} pantallas",
  "player.fullBodyOne": "Tu plan permite una pantalla a la vez. Detenla para ver aquí.",
  "player.fullBody": "Tu plan permite {count} pantallas a la vez. Detén una para ver aquí.",
  "player.stopAndWatch": "Detener {device} y ver aquí",
  "player.replacedTitle": "Detenido desde otra pantalla",
  "player.replacedBody": "Tu plan permite un número limitado de pantallas a la vez, y esta se detuvo para que otro dispositivo pudiera ver. Los planes Premium permiten dos pantallas a la vez.",
  "player.watchHere": "Ver aquí",
  "player.muted": "Silenciado",
  "player.volumePercent": "Volumen {percent} %",
  "player.behindLive": "{time} por detrás del directo. Ir al directo",
  "player.goLive": "Ir al directo",
  "player.prev": "Ant.",
  "player.next": "Sig.",
  "player.previous": "Anterior",
  "player.previousChannel": "Canal anterior",
  "player.nextChannel": "Canal siguiente",
  "player.previousEpisode": "Episodio anterior",
  "player.nextEpisode": "Episodio siguiente",
  "player.back10": "Retroceder 10 segundos",
  "player.forward10": "Avanzar 10 segundos",
  "player.play": "Reproducir",
  "player.pause": "Pausa",
  "player.audio": "Audio",
  "player.subtitles": "Subtítulos",
  "player.info": "Info",
  "player.fullscreen": "Pantalla completa",
  "player.off": "Desactivados",
  "player.quality": "Calidad",
  "player.qualityStandard": "Estándar",
  "player.qualityUnplayable": "{quality} no se puede reproducir en este dispositivo; se vuelve a la calidad anterior.",
  "player.seek": "Posición",
  "player.mute": "Silenciar",
  "player.unmute": "Activar sonido",
  "player.volume": "Volumen",
  "player.upNext": "A continuación: {name}",
  "player.playNext": "Siguiente episodio",
  "player.watchAgain": "Volver a ver",
  "playback.network": "No se pudo acceder a la emisión. Revisa tu conexión o inténtalo más tarde.",
  "playback.stalled": "La emisión dejó de enviar vídeo.",
  "playback.no-start": "La emisión no empezó. El servidor puede estar caído o ir muy lento.",
  "playback.forbidden": "El proveedor rechazó esta emisión. La cuenta puede haber llegado a su límite de conexiones.",
  "playback.not-found": "Este canal ya no está disponible en el proveedor.",
  "playback.unsupported": "El formato de esta emisión no es compatible con este dispositivo.",
  "playback.media": "No se pudo decodificar el vídeo.",
  "stats.title": "Estadísticas de reproducción",
  "stats.engine": "Motor",
  "stats.resolution": "Resolución",
  "stats.buffered": "Búfer",
  "stats.stalls": "Cortes",
  "stats.dropped": "Fotogramas perdidos",
  "stats.reconnects": "Reconexiones",
  "stats.sound": "Sonido",
  "stats.converted": "convertido a AAC",
  "stats.convertedFrom": "convertido a AAC desde {codec}",
  "stats.original": "original",
  "stats.started": "Arrancó en",
  "stats.problems": "Últimos problemas",
  "stats.none": "ninguno",
};
